import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models';

import { BookingSummaryBound } from '../../../interfaces';
import { isBusOrTrain, isFlight } from '../../../utils/common-booking.utils';

@Component({
  selector: 'fin-booking-summary-flight',
  styleUrls: ['./booking-summary-flight.component.scss'],
  templateUrl: './booking-summary-flight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingSummaryFlightComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  bound$: Observable<BookingSummaryBound>;
  @Input()
  title: string;

  flights$: Observable<FinnairItineraryItemFlight[]>;
  icon$: Observable<SvgLibraryIcon>;
  ngOnInit(): void {
    this.flights$ = this.bound$.pipe(
      filter(Boolean),
      map((bound) =>
        bound.itinerary.filter(isFlight).map((i) => ({
          ...i,
          cabinClass: isBusOrTrain(i) ? null : i.cabinClass,
        }))
      )
    );
    this.icon$ = this.bound$.pipe(
      map((bound) =>
        bound.itinerary?.filter(isFlight).some((itinerary) => isBusOrTrain(itinerary))
          ? SvgLibraryIcon.MINUS
          : SvgLibraryIcon.AIRCRAFT_HORIZONTAL
      )
    );
  }
}
